import Address from "./../components/Payment/models/address.entity";

export default class PaymentBankSlip{
  public unitValue: number = 64.90;

  public quantity: number = 1;

  public apiToken: string = process.env.REACT_APP_API_TOKEN || '';

  public userTransactionId: string = '';

  public address: Address = new Address();

  public couponCode: string = '';

  constructor(data: any = {}) {
    this.unitValue = data.unit_value || 64.90;
    this.quantity = data.quantity || 1;
    this.apiToken = data.api_token || process.env.REACT_APP_API_TOKEN;
    this.userTransactionId = data.user_transaction_id || '';
    this.address = data.address ? new Address(data.address) : new Address();
    this.couponCode = data.coupon_code || '';
  }

  public formatPayload() {
    return {
      api_token: this.apiToken || process.env.REACT_APP_API_TOKEN,
      address: this.address.formatPayload(),
      user_transaction_id: this.userTransactionId,
      coupon_code: this.couponCode,
    }
  }
}
